<template>
  <div class="body-2 ">
    <p>
      <span class="primary--text font-weight-bold ">{{ filteredCount }}</span>
      /
      {{ experiencedCount }}

      <span class="body-2">{{ $t("content.drawer.intro.respondents") }}</span>
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["filteredCount", "experiencedCount"]),
    percentOfDataSet() {
      return Math.round((this.filteredCount / this.experiencedCount) * 100);
    }
  }
};
</script>
